export const isEditable = (pipelineStatus: string): boolean => {
	return (
		!pipelineStatus?.length ||
		pipelineStatus === '' ||
		pipelineStatus === 'PCRET'
	);
};
